var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c("PageHeader", { attrs: { title: _vm.titleName, "no-padding": "" } }),
      _vm._v(" "),
      _c(
        "v-tabs",
        {
          attrs: { dark: "", grow: "", centered: "" },
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c("v-tabs-slider"),
          _vm._v(" "),
          _c("v-tab", { attrs: { href: "#approval-levels" } }, [
            _vm._v("\n      Approval Levels\n    "),
          ]),
          _vm._v(" "),
          _c("v-tab", { attrs: { href: "#data-grades" } }, [
            _vm._v("\n      Data Grades\n    "),
          ]),
          _vm._v(" "),
          _c("v-tab", { attrs: { href: "#data-qualifiers" } }, [
            _vm._v("\n      Qualifiers\n    "),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-tabs-items",
        {
          model: {
            value: _vm.currentTab,
            callback: function ($$v) {
              _vm.currentTab = $$v
            },
            expression: "currentTab",
          },
        },
        [
          _c(
            "v-tab-item",
            { attrs: { value: "approval-levels" } },
            [
              _c(
                "v-layout",
                { attrs: { wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", xl6: "", "pa-2": "" } },
                    [
                      _c("ContinuousApprovalLevelsDefaultManage", {
                        attrs: {
                          continuousDatabaseType:
                            _vm.currentTenantContinuousDatabaseType,
                          loading: _vm.ContinuousDataConfigQueryOptionIsLoading,
                          readonly: !_vm.isSystemAdmin,
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", xl6: "", "pa-2": "" } },
                    [
                      _c("ContinuousApprovalLevelsTenantManage", {
                        attrs: {
                          tenantName: _vm.tenantNameOrDefault,
                          tenantId: _vm.tenantIdOrDefault,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "data-grades" } },
            [
              _c("ContinuousDataGradesManage", {
                attrs: {
                  tenantName: _vm.tenantNameOrDefault,
                  tenantId: _vm.tenantIdOrDefault,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-tab-item",
            { attrs: { value: "data-qualifiers" } },
            [
              _c("ContinuousDataQualifiersManage", {
                attrs: {
                  tenantName: _vm.tenantNameOrDefault,
                  tenantId: _vm.tenantIdOrDefault,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }